import { render, staticRenderFns } from "./SearchWithButtons.vue?vue&type=template&id=08a6e50a&lang=pug"
import script from "./SearchWithButtons.vue?vue&type=script&lang=js"
export * from "./SearchWithButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports